import {CLEnum, CLRemoteEnum} from './enums.types';
import _keyBy from 'lodash/keyBy';
import _map from 'lodash/map';
import {CLEnumsMapper} from 'common/src/modules/enums/enums.types';

function toLocalEnum(remote: CLRemoteEnum): CLEnum {
  return {
    ...remote,
    value: +remote.value,
  };
}

function toClientEnumMapper(remoteEnums: CLEnum[]): CLEnumsMapper {
  return {
    byValue: _keyBy(remoteEnums, 'value'),
    byName: _keyBy(remoteEnums, 'name'),
    enumsForSelector: _map(remoteEnums, (obj) => {
      return {...obj, label: obj.uiName, value: String(obj.value)};
    }),
  };
}

export {toLocalEnum, toClientEnumMapper};
